import * as types from 'types/discount-code';
import * as appTypes from 'types/app';
import initialState from 'store/initial-state';
import i18n from 'i18next';
import { persistDiscountCode } from 'utils/checkoutPricingStorage';

export default function discountCodeReducer(
  state = initialState.discountCode,
  action,
) {
  switch (action.type) {
    case types.DELETE_DISCOUNT_CODE:
      persistDiscountCode(null);
      return {
        ...state,
        discountCode: null,
        error: '',
        validateDiscountCodeStatus: '',
      };
    case types.VALIDATE_DISCOUNT_CODE_REQUEST:
      return {
        ...state,
        error: '',
        responseStatus: null,
        validateDiscountCodeStatus: appTypes.STATUS_PENDING,
      };
    case types.VALIDATE_DISCOUNT_CODE_FAILURE:
      return {
        ...state,
        validateDiscountCodeStatus: appTypes.STATUS_FAILURE,
        responseStatus: action.payload.responseStatus,
        validationMessages: action.payload.validationMessages,
        error:
          action.payload.responseStatus === 404
            ? i18n.t('invalidCodeValidation')
            : action.error || i18n.t('networkErrorDiscountCode'),
      };
    case types.VALIDATE_DISCOUNT_CODE_ONLY_ONE_COUPON_ALLOWED:
      return {
        ...state,
        validateDiscountCodeStatus: appTypes.STATUS_FAILURE,
        error: i18n.t('onlyOneCouponCodeAllowed'),
        attemptedCode: action.payload.attemptedCode,
      };
    case types.VALIDATE_DISCOUNT_CODE_SUCCESS:
      persistDiscountCode(action.payload.discountCode);
      return {
        ...state,
        discountCode: action.payload.discountCode,
        validateDiscountCodeStatus: appTypes.STATUS_SUCCESS,
      };
    case types.RESET_DISCOUNT_CODE_STATUS:
      return {
        ...state,
        error: '',
        responseStatus: null,
        validateDiscountCodeStatus: '',
      };
    case types.RESTORE_PERSISTED_DISCOUNT_CODE:
      return {
        ...state,
        discountCode: action.payload.discountCode,
        validateDiscountCodeStatus: action.payload.discountCode
          ? appTypes.STATUS_SUCCESS
          : '',
      };
    default:
      return state;
  }
}
